module.exports = __webpack_public_path__ + "static/media/mail.ffd1d55f.svg";